import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import { axiosGet } from "../../util/axios";
import axios from "axios";
import ExcelJS from "exceljs";
import { insertPeopleCounterDataToExcel } from "../../util/cleaningExcel";
import {
  ChangeClickCleaningDateFolderThunk,
  initCleaningRouteThunk,
} from "../../redux/cleaning/thunk";
import { OpenLoadingBarThunk } from "../../redux/common/isLoading/thunk";
import { OpenSnackBarWithResultFail, OpenSnackBarWithResultSuccess } from "../../redux/common/snackBar/thunk";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Button, Grid, InputLabel } from "@mui/material";
import { EditNote } from "@mui/icons-material";
import { CleaningDateList } from "../../redux/cleaning/state";
import FormDialog from "../../component/common/FormDialog";
import CleaningRoute from "../../component/cleaning/CleaningRoute";
import CleaningReportDownload from "../../component/cleaning/CleaningReportDownload";
import PeopleCounterDialog from "../../component/cleaning/PeopleCounterDialog";
import styles from "./cleaning.module.css";
import { DatePicker } from "@mui/x-date-pickers";
import { infoCatelogType } from "../../interface/form";
import { handleDownLoadExcel } from "../../util/excel";
import { isGovernemnt } from "../../util/form/form";
import moment from "moment";
import { getAllDatesInYear } from "../../util/date";
import { ButtonTextGrid } from "../..";

function Cleaning() {
  const dispatch = useDispatch<IRootThunkDispatch>();
  const dataFetchedRef = useRef(false);
  const [openCleaningRouteDialog, setOpenCleaningRouteDialog] =
    useState<boolean>(false);
  const [clickExcelBtn, setClickExcelBtn] = useState<boolean>(false);
  const { cleaningDateList } = useSelector(
    (state: IRootState) => state.cleaningState
  );
  const { user } = useSelector((state: IRootState) => state.userAuth);
  const isGovernmentRole = isGovernemnt(user?.token?.role_id as number);
  const [excelDownloadStartDate, setExcelDownloadStartDate] = useState<
    moment.Moment | Date | null
  >(null);
  const [excelDownloadEndDate, setExcelDownloadEndDate] = useState<
    moment.Moment | Date | null
  >(null);

  const [dataArray, setDataAray] = useState([{ id: 0 }]);
  const [openPeopleCounterDialog, setOpenPeopleCounterDialog] = useState<boolean>(false);
  // useEffect(() => {
  //     const controller = new AbortController();
  //     if (dataFetchedRef.current) return;
  //     dataFetchedRef.current = true;
  //     getCleaningDate();
  //     return () => {
  //         controller.abort();
  //     };
  // }, []);

  useEffect(() => {
    const currentYear = moment().year();
    const datesInYear = getAllDatesInYear(currentYear);
    const dataArrayList = datesInYear.map((item, index) => ({
      id: index,
      date: item,
      weekday: new Date(item).toLocaleString("en-US", {
        weekday: 'short',
      }),
    }));

    console.log("dataArrayList", dataArrayList);
    setDataAray(dataArrayList);
  }, []);

//   async function getCleaningDate() {
//     dispatch(OpenLoadingBarThunk(true));
//     const result = await axiosGet("/api/cleaning/date/cleaning");
//     dispatch(OpenLoadingBarThunk(false));
//     if (result.data.success) {
//       dispatch(initCleaningDateThunk(result.data.CleaningDateList));
//     } else {
//       dispatch(OpenSnackBarWithResultFail("未能取得清潔日期"));
//     }
//   }

  async function handleClickDetailCleaning(cleaningDateList: CleaningDateList) {
  

    const date = moment(cleaningDateList.date).format("YYYYMMDD") 
    
    dispatch(ChangeClickCleaningDateFolderThunk(date))

    dispatch(OpenLoadingBarThunk(true));
    const result = await axiosGet(
      `/api/cleaning/date/cleaningRoute?date=${date}&&day=${cleaningDateList.weekday.toLowerCase()}`
    );
    dispatch(OpenLoadingBarThunk(false));

    if (result.data.success) {
      dispatch(initCleaningRouteThunk(result.data.cleaningRouteCMS));
      setOpenCleaningRouteDialog(true);
    } else {
      dispatch(OpenSnackBarWithResultFail("未能取得清潔路線"));
    }
  }

  function handleCloseDialog() {
    setOpenCleaningRouteDialog(false);
  }

  function handleClickExcelBtn() {
    setClickExcelBtn(!clickExcelBtn);
  }

  function handleDownloadStartDate(date: moment.Moment | Date | null) {
    setExcelDownloadStartDate(date);
  }

  function handleDownloadEndDate(date: moment.Moment | Date | null) {
    setExcelDownloadEndDate(date);
  }

  function DownloadExcel(type: infoCatelogType) {
    if (excelDownloadStartDate && excelDownloadEndDate) {
      handleDownLoadExcel(
        dispatch,
        type,
        excelDownloadStartDate as Date,
        excelDownloadEndDate as Date
      );
    } else {
      dispatch(OpenSnackBarWithResultFail("未有填寫開始及完結日期"));
    }
  }

  function handleOpenPeopleCounterDialog() {
    setOpenPeopleCounterDialog(true);
  }

  function handleClosePeopleCounterDialog() {
    setOpenPeopleCounterDialog(false);
  }

  async function handlePeopleCounterSubmit(
    reportType: string,
    selectedDate?: moment.Moment | null
  ) {
    setOpenPeopleCounterDialog(false);
    dispatch(OpenLoadingBarThunk(true));
    try {
      const token = localStorage.getItem('loginToken');
      const params: Record<string, string> = {};
      
      if (selectedDate) {
        params.date = selectedDate.format('YYYY-MM');
      }
      
      const response = await axios.get(
        `${process.env.REACT_APP_API}api/download/cleaningPeopleCounterByMonth`,
        {
          headers: {
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` })
          },
          params
        }
      );
      
      if (!response.data || !response.data.data) {
        dispatch(OpenLoadingBarThunk(false));
        dispatch(OpenSnackBarWithResultFail("未能取得數據"));
        setOpenPeopleCounterDialog(false);
        return;
      }
      
      const peopleCounterData = response.data.data;
      
      const templateFileName = reportType === "129PeopleCounter" 
        ? "129_25 - People Counter Report - Convert Template.xlsx"
        : "139_25 - People Counter Report - Convert Template.xlsx";
      
      const templateResponse = await fetch(`/templates/${templateFileName}`);
      if (!templateResponse.ok) {
        dispatch(OpenLoadingBarThunk(false));
        dispatch(OpenSnackBarWithResultFail(`無法載入模板文件: ${templateFileName}`));
        setOpenPeopleCounterDialog(false);
        return;
      }
      
      const templateArrayBuffer = await templateResponse.arrayBuffer();
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(templateArrayBuffer);
      
      await insertPeopleCounterDataToExcel(workbook, peopleCounterData, selectedDate);
      
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      const fileName = `${reportType}_${selectedDate?.format('YYYYMM') || 'report'}.xlsx`;
      
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      dispatch(OpenLoadingBarThunk(false));
      dispatch(OpenSnackBarWithResultSuccess("文件下載成功"));
      setOpenPeopleCounterDialog(false);
    } catch (error) {
      dispatch(OpenLoadingBarThunk(false));
      dispatch(OpenSnackBarWithResultFail("未能生成文件"));
      setOpenPeopleCounterDialog(false);
    }
  }


  const columns: GridColDef[] = [
    {
      field: "route_cleaning_id",
      headerName: "清潔編號",
      flex: 1,
    },
    {
      field: "date",
      headerName: "日期",
      width: 300,
      flex: 2,
      valueGetter: (params) =>
        params.row.date ? moment(params.row.date).format("YYYY-MM-DD") : null,
    },
    { field: "weekday", headerName: "工作日", flex: 1 },
    {
      field: "action",
      headerName: "清潔詳情",
      flex: 1,
      renderCell: (data) => (
        <div>
          <Button
            variant="contained"
            onClick={() => handleClickDetailCleaning(data.row)}
          >
            <ButtonTextGrid>
            <EditNote />
            <Grid>詳情</Grid>

            </ButtonTextGrid>
          </Button>
        </div>
      ),
    },

    {
      field: "download",
      headerName: "下載當日報告",
      flex: 1,
      renderCell: (data) => (
        <CleaningReportDownload rowData={data.row} />
      ),
    },
  ];

  return (
    <>
      {isGovernmentRole ? (
        <></>
      ) : (
        <Grid className={styles.excelBtnOuterContainer}>
          <Button variant="contained" onClick={handleClickExcelBtn}>
                                     <ButtonTextGrid>
            Excel

                                     </ButtonTextGrid>
           
          </Button>
          <Button 
            variant="contained" 
            onClick={handleOpenPeopleCounterDialog}
            sx={{ ml: 2 }}
          >
                          <ButtonTextGrid>
            人流報告

                          </ButtonTextGrid>

          </Button>
        </Grid>
      )}

      {clickExcelBtn ? (
        <Grid className={styles.excelTimeOuterContainer}>
          <Grid>
            <InputLabel htmlFor="enquiry-date-picker">開始時間</InputLabel>
            <DatePicker
              onChange={(data) => handleDownloadStartDate(data! as Date)}
              value={excelDownloadStartDate}
              format="YYYY-MM-DD"
            />
          </Grid>
          <Grid>
            <InputLabel htmlFor="enquiry-date-picker">完結時間</InputLabel>
            <DatePicker
              onChange={(data) => handleDownloadEndDate(data! as Date)}
              value={excelDownloadEndDate}
              format="YYYY-MM-DD"
            />
          </Grid>

          <Grid>
            <Button
              variant="contained"
              onClick={() => DownloadExcel("Cleaning")}
            >
              <ButtonTextGrid>
              下載

              </ButtonTextGrid>
            </Button>
          </Grid>
        </Grid>
      ) : (
        <></>
      )}

      <div style={{ height: "900px", width: "100%" }}>
        <DataGrid
          rows={dataArray || []}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 30 },
            },
          }}
          pageSizeOptions={[5, 10]}
          checkboxSelection
        />
      </div>

      <FormDialog
        title="詳細情況"
        open={openCleaningRouteDialog}
        handleClose={handleCloseDialog}
        size="lg"
      >
        <CleaningRoute />
      </FormDialog>

      <PeopleCounterDialog
        open={openPeopleCounterDialog}
        onClose={handleClosePeopleCounterDialog}
        onSubmit={handlePeopleCounterSubmit}
      />

    </>
  );
}

export default Cleaning;
